import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";

import { NotFound } from "@/components/layout/NotFound";
import { RootLayout } from "@/components/layout/RootLayout";
import { AdminPage } from "@/pages/AdminPage";
import { PanelPage } from "@/pages/PanelPage";

const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

const panelRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: PanelPage,
});

/** `flik` styr vilken flik som visas; `fortnox`/`fortnox_fel` sätts av OAuth-callbacken. */
export type AdminSearch = {
  flik?: string;
  fortnox?: string;
  fortnox_fel?: string;
};

const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin",
  validateSearch: (search: Record<string, unknown>): AdminSearch => ({
    flik: typeof search.flik === "string" ? search.flik : undefined,
    fortnox: typeof search.fortnox === "string" ? search.fortnox : undefined,
    fortnox_fel: typeof search.fortnox_fel === "string" ? search.fortnox_fel : undefined,
  }),
  component: AdminPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([panelRoute, adminRoute]),
  defaultPreload: false,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
